<template>
  <Drawer
    width="800"
    :title="`${
      openedReceive && openedType !== 'create' ? '编辑' : '新增'
    }回款记录`"
    v-model="drawerOpened"
    :mask-closable='false'
    :transfer="false"
  >
    <Modal
      width="800"
      v-model="isShowchooseBillModal"
    >
      <div
        class="table-wrapper"
        ref="tableWrapper"
      >
        <div class="handle-wrapper">
          <div class="handle-left">
            <Input
              v-model="searchBillText"
              search
              placeholder="搜索简称..."
              @on-change="searchBankAccount"
              clearable
              icon="ios-search"
              style="width: 250px; margin-right: 20px"
            >
            </Input>
          </div>
          <div class="handle-right">
            <span>共{{ totalRows }}条</span>
            <Page
              :total="totalRows"
              :page-size="15"
              @on-change="loadBill"
              show-total
              simple
              style="margin-right: 24px"
            />
          </div>
        </div>
        <Table
          :columns="columns"
          :data="billList"
          :height="tableHeight"
          @on-row-click='chooseBill'
        > </Table>
      </div>
    </Modal>
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <div class="formItem">
          <div
            class="formItem-left"
            :style="formItemStyle"
          >
            <FormItem
              label="收款项目"
              prop="fromModel"
            >
              <div v-if="openedReceive">
                {{ fromModelToTextMethod(formItem.receiveItem) }}
              </div>
              <RadioGroup
                v-else
                v-model="formItem.receiveItem"
                @on-change="changeFromModel"
              >
                <Radio label="huokuan">
                  <span>客户货款</span>
                </Radio>
                <Radio label="buzhu">
                  <span>政府补助</span>
                </Radio>
                <Radio label="tuibzj">
                  <span>退保证金</span>
                </Radio>
                <Radio label="yinhang">
                  <span>银行放款</span>
                </Radio>
                <Radio label="gl-huokuan">
                  <span>关联公司收货款</span>
                </Radio>
                <Radio label="gl-jiekuan">
                  <span>关联公司还借款</span>
                </Radio>
                <Radio label="gl-others">
                  <span>关联公司的其他收款</span>
                </Radio>
                <Radio label="others">
                  <span>其他</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem
              :label="receiveLabel"
              prop="from"
              v-if="formItem.receiveItem !== 'others'"
            >
              <Select
                v-model="formItem.from"
                filterable
                :disabled="openedReceive || isPayToDisabled ? true : false"
                remote
                clearable
                style="width: 366px"
                :remote-method="remoteMethod"
                :loading="customerLoading"
                :placeholder="placeholder"
                @on-change='selectedCustomer'
              >
                <Option
                  v-for="option in payToList"
                  :value="option._id"
                  :key="option._id"
                  style="width: 366px"
                >{{ option.name }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="收款内容"
              prop="content"
            >
              <Input
                style="width: 366px"
                v-model="formItem.content"
                type="textarea"
                placeholder="输入收款内容..."
              />
            </FormItem>
            <FormItem
              label="收款公司"
              prop="company"
            >
              <Select
                @on-change="chooseCompany"
                v-model="formItem.company"
                filterable
                clearable
              >
                <Option
                  v-for="option in companyList"
                  :value="option._id"
                  :key="option._id"
                >{{ option.name }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="责任人"
              prop="receivedBy"
            >
              <Select
                v-model="formItem.receivedBy"
                filterable
                clearable
              >
                <Option
                  v-for="option in simpleUserList"
                  :value="option._id"
                  :key="option._id"
                >{{ option.name }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="创建人"
              prop="createdBy"
            >
              <div>
                {{
                  openedReceive
                    ? openedReceive.createdBy
                      ? openedReceive.createdBy.name
                      : ""
                    : user.name
                }}
              </div>
            </FormItem>
            <FormItem
              label="创建时间"
              prop="createdAt"
            >
              <div>
                {{
                  openedReceive
                    ? openedReceive.createdAt
                      : currentDate
                }}
              </div>
            </FormItem>
            <FormItem
              label="备注"
              prop="remark"
            >
              <Input
                style="width: 366px"
                v-model="formItem.remark"
                type="textarea"
                placeholder="输入备注..."
              />
            </FormItem>
          </div>
          <div
            class="formItem-right"
            :style="formItemStyle"
          >
            <FormItem
              label="收款账号"
              prop="bankAccount"
            >
              <Select
                :disabled="disabled"
                v-model="formItem.bankAccount"
                filterable
                clearable
              >
                <Option
                  v-for="option in bankAccountList"
                  :value="option._id"
                  :key="option._id"
                >{{ option.abbr }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="回款类型"
              prop="type"
            >
              <div v-if="openedReceive && formItem.status !='needConfirm'">
                {{ typeText }}
              </div>
              <RadioGroup
                v-else
                v-model="receiveType"
                @on-change="changType"
              >
                <Radio label="trans">
                  <span>银行转账</span>
                </Radio>
                <Radio label="cash">
                  <span>现金钞票</span>
                </Radio>
                <Radio label="bill">
                  <span>票据</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <div
              v-if=" isShowBillButton "
              class="show-bill-button"
            >
              <Button
                type="primary"
                ghost
                class="createBill"
                @click="openCreateNewBillDrawer"
              >创建新票据</Button>
              <Button
                type="primary"
                ghost
                @click="openChooseBillDrawer"
              >选择票据</Button>
            </div>
            <div
              v-if="bill._id"
              class="bill-card"
              @click="openEditBillDrawer"
            >
              <Card style="width: 100%">
                <template #title>
                  <div class="bill-list-title">
                    <div>{{typeToTextMethod(bill.type)}}</div>
                    <div>{{bill.billNo}}</div>
                  </div>
                </template>
                <div class="bill-content">
                  <h2>{{amountToLocaleString(bill.amount)}}元</h2>
                  <div>{{dateformatConversion(bill.billEndedAt)}}</div>
                  <div>{{bill.billCompany}}</div>
                  <div>{{bill.billBank}}</div>
                  <div>{{billStatusToTextMethod(bill.billStatus)}}</div>
                  <div>{{billTagsToTextMethod(bill.tags)}}</div>
                </div>
              </Card>
            </div>
            <FormItem
              prop="submitAmount"
              v-if="openedReceive"
              label="业务员提交金额（元）"
            >
              <div>{{ formItem.submitAmount?formItem.submitAmount:"-" }}</div>
            </FormItem>
            <FormItem
              label="实际金额（元）"
              prop="amount"
            >
              <div v-if="openedReceive && openedReceive.bill">
                {{ formItem.amount }}
              </div>
              <InputNumber
                v-else
                style="width: 200px"
                :min="0"
                v-model="formItem.amount"
              ></InputNumber>
              <div v-if="openedReceive && openedReceive.bill">以票据为准</div>
            </FormItem>
            <FormItem
              label="收到此现金或票据的日期"
              prop="receivedAt"
            >
              <DatePicker
                type="date"
                v-model="formItem.receivedAt"
                placeholder="选择到账日期"
                @on-change='changeReceivedAt'
              ></DatePicker>
            </FormItem>

            <FormItem
              label="状态"
              prop="status"
            >
              <RadioGroup v-model="formItem.status">
                <Radio label="needConfirm">
                  <span>需财务确认</span>
                </Radio>
                <Radio label="confirmed">
                  <span>已确认</span>
                </Radio>
                <Radio label="rejected">
                  <span>财务拒绝</span>
                </Radio>
                <Radio label="cancelled">
                  <span>业务员取消</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem
              label="锁定"
              prop="isLocked"
            >
              <RadioGroup v-model="isLocked">
                <Radio
                  v-for="item in isLockRadios"
                  :key="item.value"
                  :label="item.value"
                >{{ item.label }}</Radio>
              </RadioGroup>
            </FormItem>
          </div>
        </div>
        <div class="bottom-button">
          <FormItem
            v-if="openedType === 'needConfirm'"
            style="margin-left: 16px;margin-bottom: 0"
          >
            <Button
              type="primary"
              @click="verifyAndUpdateReceive('formItem')"
            >审核通过并保存</Button>
          </FormItem>
          <FormItem
            v-if="
              openedType === 'confirmed' ||
              openedType === 'needConfirm' ||
              openedType === 'create'
            "
            style="margin-left: 16px;margin-bottom: 0"
          >
            <Button
              type="primary"
              @click="handleSubmit('formItem')"
              :loading="handleSubmitLoading"
            >保存</Button>
          </FormItem>
          <FormItem
            style="margin-left: 16px;margin-bottom: 0"
            v-if="openedType === 'needConfirm'"
          >
            <Button
              type="error"
              ghost
              @click="refuseReceiveMethod('formItem')"
            >拒绝</Button>
          </FormItem>
          <FormItem
            style="margin-left: 16px;margin-bottom: 0"
            v-if="openedType !== 'create'"
          >
            <Button
              type="primary"
              ghost
              @click="copyNewReceive()"
            >复制回款</Button>
          </FormItem>
          <FormItem style="margin-left: 16px;margin-bottom: 0">
            <Button
              type="error"
              ghost
              @click="drawerOpened = false"
            >关闭</Button>
          </FormItem>
        </div>
      </Form>
    </div>
    <AddBillDrawer
      ref="AddBillDrawer"
      @updateBill="updateBill"
    />
  </Drawer>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";
import dayjs from "dayjs";
import lodash from "lodash";
import AddBillDrawer from "../BillPage/AddBillDrawer.vue";

const fromModelToText = {
  huokuan: "客户货款",
  buzhu: "政府补助",
  tuibzj: "退保证金",
  yinhang: "银行放款",
  "gl-huokuan": "关联公司收货款",
  "gl-jiekuan": "关联公司还借款",
  "gl-others": "关联公司的其他收款",
  others: "其他",
};
const billStatusToText = {
  waiting: "未到期",
  receive: "到期兑现",
  overdue: "逾期无法兑现",
  paid: "背书给供应商",
  partPaid: "部分支付",
};

const typeToText = {
  trans: "银行转账",
  bankAccBill: "银承",
  commAccBill: "商承",
  check: "支票",
  cash: "现金钞票",
  yun: "云信通",
  jian: "建信融通",
  bankAccBillPaper: "纸质银承",
  gold: "金单",
  sywx: "商银微芯",
  ji: "集信",
  zhu: "筑信",
};
const billTagsToText = {
  heimingdan: "黑名单",
  ketiexian: "可贴现",
  "6+9": "6+9",
};
export default {
  name: "EditReceiveDrawer",
  components: { AddBillDrawer },
  data() {
    return {
      drawerOpened: false,
      type: null,
      receiveType: null,
      openedReceive: null,
      customerLoading: false,
      disabled: true,
      handleSubmitLoading: false,
      typeList: [
        {
          value: "trans",
          label: "银行转账",
        },
        {
          value: "bankAccBill",
          label: "银承",
        },
        {
          value: "commAccBill",
          label: "商承",
        },
        {
          value: "check",
          label: "支票",
        },
        {
          value: "cash",
          label: "现金钞票",
        },
        {
          value: "bankAccBillPaper",
          label: "纸质银承",
        },
      ],
      isLockRadios: [
        { label: "锁定", value: "true" },
        { label: "可修改", value: "false" },
      ],
      formItem: {
        from: null,
        company: null,
        amount: null,
        type: null,
        bankAccount: null,
        receivedAt: null,
        receivedBy: null,
        remark: null,
        submitAmount: null,
        status: null,
        fromModel: null,
        receiveItem: null,
        content: null,
      },
      isLocked: "false",
      bankAccountList: [],
      ruleValidate: {
        from: [
          { required: true, message: "收款对象为必填项", trigger: "submit" },
        ],
        company: [
          { required: true, message: "收款公司为必填项", trigger: "submit" },
        ],
        amount: [
          {
            required: true,
            message: "价格为必填项",
            trigger: "submit",
            type: "number",
          },
        ],
        type: [
          {
            required: true,
            message: "回款类型为必填项",
            trigger: "submit",
          },
        ],
        receivedAt: [
          {
            required: true,
            message: "到账日期为必填项",
            trigger: "submit",
            type: "string",
          },
        ],
        receivedBy: [
          { required: true, message: "责任人为必填项", trigger: "submit" },
        ],
        content: [
          {
            required: false,
            message: "收款内容为必填",
            trigger: "submit",
          },
        ],
      },
      bill: {},
      receiveLabel: "先选择收款项目",
      placeholder: "请选择收款项目后选择",
      openedType: "create",
      status: null,
      isPayToDisabled: true,
      payToList: null,
      formItemStyle: {
        overflowY: "hidden",
        overflowX: "hidden",
        height: 700,
      },
      typeText: null,
      isShowBillButton: false,
      isShowchooseBillModal: false,
      searchBillText: null,
      filterQuery: {},
      page: 0,
      tableLoading: false,
      limit: 20,
      columns: [
        {
          title: "汇票状态",
          minWidth: 80,
          key: "billStatus",
          align: "left",
          render: (h, params) =>
            h("span", billStatusToText[params.row.billStatus]),
        },
        {
          title: "出票银行",
          minWidth: 160,
          key: "billBank",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.billBank
            ),
        },
        {
          title: "票据类型",
          minWidth: 80,
          key: "type",
          align: "left",
          render: (h, params) => h("span", typeToText[params.row.type]),
        },
        {
          title: "客户",
          minWidth: 180,
          key: "customer",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                },
                params.row.paidByCustomer ? params.row.paidByCustomer.name : ""
              ),
            ]);
          },
        },
        {
          title: "公司",
          key: "company",
          minWidth: 80,
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.company.abbr
                ? params.row.company.abbr
                : params.row.company.name
            ),
        },
        {
          title: "金额",
          key: "amount",
          minWidth: 100,
          align: "right",
          render: (h, params) =>
            h(
              "span",
              params.row.amount ? params.row.amount.toLocaleString() : ""
            ),
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          minWidth: 110,
          render: (h, params) =>
            h("span", params.row.createdBy ? params.row.createdBy.name : ""),
        },
        {
          title: "备注",
          minWidth: 100,
          key: "remark",
          align: "center",
          render: (h, params) => h("span", params.row.remark),
        },
        {
          title: "标签",
          key: "tags",
          align: "left",
          minWidth: 80,
          render: (h, params) =>
            h(
              "span",
              params.row.tags
                ? params.row.tags.map((x) => billTagsToText[x]).join(",")
                : ""
            ),
        },
        {
          title: "汇票编号",
          minWidth: 160,
          key: "billNo",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.billNo
            ),
        },
        {
          title: "出票公司",
          minWidth: 160,
          key: "billCompany",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.billCompany
            ),
        },

        {
          title: "出票日期",
          minWidth: 110,
          key: "billIssuedAt",
          render: (h, params) =>
            h(
              "span",
              params.row.billIssuedAt
                ? dayjs(params.row.billIssuedAt).format("YYYY-MM-DD")
                : ""
            ),
        },
        {
          title: "汇票到期",
          minWidth: 110,
          key: "billEndedAt",
          render: (h, params) =>
            h(
              "span",
              params.row.billEndedAt
                ? dayjs(params.row.billEndedAt).format("YYYY-MM-DD")
                : ""
            ),
        },
      ],
      currentDate: null,
      tableHeight: 500,
    };
  },
  computed: {
    ...mapState({
      companyList: (state) => state.company.companyList,
      simpleBankAccount: (state) => state.bankAccount.simpleBankAccount,
      customersSimple: (state) => state.customer.customersSimple,
      entityList: (state) => state.entity.entityList,
      user: (state) => state.auth.currentUser,
      simpleUserList: (state) => state.user.simpleUserList,
      billsList: (state) => state.receive.billsList,
      totalRows: (state) => state.bill.totalCounts,
      billList: (state) => state.bill.billList,
    }),
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      createReceive: "receive/createReceiveAction",
      updateReceive: "receive/updateReceiveAction",
      getBill: "bill/getBillAction",
      updateLocalReceive: "receive/updateLocalReceiveAction",
      getCustomerDefaultReceiveInfo:
        "receive/getCustomerDefaultReceiveInfoAction",
      getCompanyList: "company/getCompanyListAction",
      getEntity: "entity/getEntityAction",
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
    }),
    fromModelToTextMethod(fromModel) {
      return fromModelToText[fromModel];
    },
    billStatusToTextMethod(billStatus) {
      return billStatusToText[billStatus];
    },
    billTagsToTextMethod(billTags) {
      if (billTags) {
        return billTags.map((x) => billTagsToText[x]).join("，");
      }
    },
    typeToTextMethod(type) {
      return typeToText[type];
    },
    amountToLocaleString(amount) {
      if (amount) {
        return amount.toLocaleString();
      } else {
        return "-";
      }
    },
    dateformatConversion(date) {
      let dateText = null;
      const diffMonths = dayjs(date).diff(dayjs(), "months");
      if (diffMonths > 0) {
        const afterMonths = dayjs().add(diffMonths, "month");
        const diffDay = dayjs(date).diff(afterMonths, "day");
        dateText = `（还剩${diffMonths}个月${diffDay}日）`;
        return dayjs(date).format("YYYY年M月DD日") + dateText;
      } else if (diffMonths === 0) {
        const diffDay = dayjs(date).diff(dayjs(), "day");
        if (diffDay > 0) {
          dateText = `（还剩${diffDay}日）`;
          return dayjs(date).format("YYYY年M月DD日") + dateText;
        } else {
          return dayjs(date).format("YYYY年M月DD日") + "（已到期）";
        }
      } else {
        return dayjs(date).format("YYYY年M月DD日") + "（已到期）";
      }
    },
    changeFromModel(e) {
      this.formItem.from = null;
      this.isPayToDisabled = false;
      this.payToList = null;
      switch (e) {
        case "huokuan":
          this.receiveLabel = "客户";
          this.formItem.fromModel = "Customer";
          this.ruleValidate.content[0].required = false;
          this.placeholder = "选择客户";
          break;
        case "buzhu":
          this.ruleValidate.content[0].required = true;
          this.formItem.fromModel = "Entity";
          this.receiveLabel = "政府（机构）";
          this.placeholder = "选择机构";
          break;
        case "tuibzj":
          this.ruleValidate.content[0].required = false;
          this.formItem.fromModel = "Customer";
          this.receiveLabel = "客户";
          this.placeholder = "选择客户";
          break;
        case "yinhang":
          this.ruleValidate.content[0].required = false;
          this.formItem.fromModel = "Entity";
          this.receiveLabel = "银行（机构）";
          this.placeholder = "选择机构";
          break;
        case "gl-huokuan":
          this.ruleValidate.content[0].required = false;
          this.formItem.fromModel = "Company";
          this.receiveLabel = "关联公司";
          this.placeholder = "选择关联公司";
          break;
        case "gl-jiekuan":
          this.ruleValidate.content[0].required = false;
          this.formItem.fromModel = "Company";
          this.receiveLabel = "关联公司";
          this.placeholder = "选择关联公司";
          break;
        case "gl-others":
          this.ruleValidate.content[0].required = false;
          this.formItem.fromModel = "Company";
          this.receiveLabel = "关联公司";
          this.placeholder = "选择关联公司";
          break;
        case "others":
          this.ruleValidate.content[0].required = true;
          this.ruleValidate.from[0].required = false;
          delete this.formItem.fromModel;
          break;
      }
    },
    // 选择客户
    async remoteMethod(query) {
      if (query !== "" && !this.openedReceive) {
        this.customerLoading = true;
        switch (this.formItem.fromModel) {
          case "Customer":
            await this.getCustomerSimpleList({ name: query });
            this.payToList = this.customersSimple;
            break;
          case "Entity":
            if (this.formItem.receiveItem === "yinhang") {
              await this.getEntity({ type: "bank", name: query });
            } else {
              await this.getEntity({ type: "gov", name: query });
            }

            this.payToList = this.entityList;
            break;
          case "Company":
            this.payToList = this.companyList;
            break;
          case "others":
            // this.payToList = this.simpleUserList;
            break;
        }
        this.customerLoading = false;
      }
    },
    async selectedCustomer(e) {
      if (e) {
        const data = await this.getCustomerDefaultReceiveInfo(e);
      }
    },
    async openDrawer(receive, type) {
      this.$refs["formItem"].resetFields();
      this.isPayToDisabled = true;
      this.openedReceive = null; // 如果有打开，则为编辑模式
      this.status = null;
      this.receiveType = null;
      this.bill = {};
      Object.keys(this.formItem).forEach((key) => (this.formItem[key] = null));
      Object.keys(this.bill).forEach((key) => (this.bill[key] = null));
      this.currentDate = dayjs().format('YYYY-M-D')
      this.openedType = type ? type : "create";
      this.openedReceive = receive; // 如果有打开，则为编辑模式
      if (receive) {
        this.openedReceive.createdAt = dayjs(receive.createdAt).format('YYYY-M-D')
        this.status = receive.status;
        this.openedType = receive.status;
        this.formItem.fromModel = receive.fromModel;
        this.formItemStyle.overflowY = "scroll";
        switch (receive.fromModel) {
          case "Supplier":
            await this.getSupplier({ name: receive.from.name });
            this.payToList = this.supplierList;
            break;
          case "Customer":
            await this.getCustomerSimpleList({ name: receive.from.name });
            this.payToList = this.customersSimple;
            this.receiveLabel = "客户";
            break;
          case "User":
            this.payToList = this.simpleUserList;
            break;
          case "Entity":
            await this.getEntity({ name: receive.from.name });
            this.payToList = this.entityList;
            break;
          case "Company":
            // await this.getCompanyList({ searchText: receive.from.name });
            this.payToList = this.companyList;
            break;
        }
        if (receive.from) {
          // await this.getCustomerSimpleList({ name: receive.from.name });
          this.formItem.from = receive.from._id;
        }
        this.formItem.type = receive.type;
        this.formItem.receiveItem = receive.receiveItem;
        this.formItem.content = receive.content ? receive.content : null;
        this.formItem.amount = receive.amount ? receive.amount : null;
        this.formItem.submitAmount = receive.submitAmount
          ? receive.submitAmount
          : null;
        this.formItem.bankAccount = receive.bankAccount
          ? receive.bankAccount._id
          : null;
        // 判断该公司是否有账号并自动填写
        if (receive.company) {
          this.formItem.company = receive.company._id;
          this.bankAccountList = this.simpleBankAccount;
          this.bankAccountList = this.bankAccountList.filter((x) => {
            return x.company._id === receive.company._id;
          });
          this.disabled = false;
        } else {
          this.disabled = true;
        }
        this.formItem.receivedAt = receive.receivedAt;
        this.formItem.receivedBy = receive?.receivedBy._id;
        if (
          receive.type === "bankAccBill" ||
          receive.type === "commAccBill" ||
          receive.type === "check" ||
          receive.type === "yun" ||
          receive.type === "jian" ||
          receive.type === "bankAccBillPaper" ||
          receive.type === "gold" ||
          receive.type === "sywx" ||
          receive.type === "ji" ||
          receive.type === "zhu"
        ) {
          this.typeText = "票据";
          this.receiveType = "bill";
          this.isShowBillButton = receive.bill ? false : true;
          this.bill.billNo = receive.bill?.billNo;
          this.bill.billCompany = receive.bill?.billCompany;
          this.bill.billBank = receive.bill?.billBank;
          this.bill.type = receive.bill?.type;
          this.bill.amount = receive.bill?.amount;
          this.bill.billIssuedAt = dayjs(receive.bill?.billIssuedAt).format(
            "YYYY-MM-DD"
          );
          this.bill.billEndedAt = dayjs(receive.bill?.billEndedAt).format(
            "YYYY-MM-DD"
          );
          this.bill.billStatus = receive.bill?.billStatus;
          this.bill.tags = receive.bill?.tags;
          this.bill._id = receive.bill?._id;
        } else {
          this.receiveType = receive.type;
          switch (receive.type) {
            case "trans":
              this.typeText = "银行转账";
              break;
            case "cash":
              this.typeText = "现金钞票";
              break;
          }
          this.formItem.billNo = null;
          this.formItem.billCompany = null;
          this.formItem.billBank = null;
          this.formItem.billIssuedAt = null;
          this.formItem.billEndedAt = null;
          this.formItem.billStatus = null;
          this.formItem.tags = null;
        }
        this.formItem.createdBy = receive?.createdBy?._id;
        this.isLocked = receive.isLocked.toString();
        this.formItem.remark = receive.remark;
        this.formItem.status = receive.status;
      } else {
        this.formItem.status = "confirmed";
      }
      this.drawerOpened = true;
    },
    changType(e) {
      if (e === "bill") {
        this.isShowBillButton = true;
      } else {
        this.formItem.type = e;
        this.isShowBillButton = false;
        this.bill = {};
        delete this.formItem.bill;
        this.formItem.amount = null;
        this.getHeight();
      }
    },
    // 选择公司
    async chooseCompany(company) {
      if (company) {
        this.formItem.bankAccount = null;
        this.bankAccountList = this.simpleBankAccount;
        // 选择公司后筛选出该公司下的账号
        this.bankAccountList = this.bankAccountList.filter((x) => {
          return x.company._id === company;
        });

        if (this.bankAccountList.length > 0) {
          this.formItem.bankAccount = this.bankAccountList[0]._id;
        }
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    changeReceivedAt(e) {
      this.formItem.receivedAt = dayjs(this.formItem.receivedAt).format(
        "YYYY-M-DD"
      );
    },
    openCreateNewBillDrawer() {
      this.$refs.AddBillDrawer.openDrawer(null, "create");
    },
    async loadBill(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.name = this.searchText;
      } else {
        delete this.filterQuery.name;
      }
      try {
        this.tableLoading = true;
        await this.getBill(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    async openChooseBillDrawer() {
      this.isShowchooseBillModal = true;
      await this.loadBill();
    },
    searchBankAccount() {
      this.page = 0;
      this.loadBill();
    },
    chooseBill(bill) {
      this.bill = bill;
      this.formItem.amount = bill.amount;
      this.formItem.bill = bill._id;
      this.formItem.type = bill.type;
      this.isShowchooseBillModal = false;
    },
    cancelchooseBill() {},
    // 拒绝
    async refuseReceiveMethod() {
      try {
        const data = await this.updateReceive({
          id: this.openedReceive._id,
          data: { status: "rejected" },
        });
        this.openedReceive = data;
        this.status = data.status;
        this.$Message.success("已拒绝该笔回款");
      } catch (error) {
        this.$Message.error("审核错误：" + error);
      }
    },
    // 审核通过并保存
    async verifyAndUpdateReceive(name) {
      if (!this.formItem.amount) {
        this.formItem.amount = this.formItem.submitAmount;
      }
      if (!this.formItem.receivedAt) {
        this.formItem.receivedAt = new Date();
      }
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            switch (this.isLocked) {
              case "true":
                this.formItem.isLocked = true;
                break;
              case "false":
                this.formItem.isLocked = false;
                break;
            }
            let formItem = lodash.cloneDeep(this.formItem);
            for (const key in formItem) {
              if (
                Object.prototype.toString.call(this.openedReceive[key]) ===
                "[object Object]"
              ) {
                if (formItem[key] === this.openedReceive[key]._id) {
                  delete formItem[key];
                }
              } else {
                if (formItem[key] === this.openedReceive[key]) {
                  delete formItem[key];
                }
              }
            }
            formItem.status = "confirmed";
            await this.updateReceive({
              id: this.openedReceive._id,
              data: formItem,
            });
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error({
            content: "保存失败!",
            closable: true,
            duration: 0,
          });
        }
      });
    },
    // 更新和创建
    handleSubmit(name) {
      this.handleSubmitLoading = true;
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          switch (this.isLocked) {
            case "true":
              this.formItem.isLocked = true;
              break;
            case "false":
              this.formItem.isLocked = false;
              break;
          }
          try {
            if (this.openedReceive && this.openedType !== "create") {
              let formItem = lodash.cloneDeep(this.formItem);
              for (const key in formItem) {
                if (
                  Object.prototype.toString.call(this.openedReceive[key]) ===
                  "[object Object]"
                ) {
                  if (
                    formItem[key] === this.openedReceive[key]._id ||
                    formItem[key] == null
                  ) {
                    delete formItem[key];
                  }
                } else {
                  if (
                    formItem[key] === this.openedReceive[key] ||
                    formItem[key] == null
                  ) {
                    delete formItem[key];
                  }
                }
              }
              await this.updateReceive({
                id: this.openedReceive._id,
                data: formItem,
              });
            } else {
              let formItem = lodash.cloneDeep(this.formItem);
              if (!formItem.bankAccount) {
                delete formItem.bankAccount;
              }
              for (const key in formItem) {
                if (!formItem[key]) {
                  delete formItem[key];
                }
              }

              const type = formItem.type;
              if (type === "trans" || type === "cash") {
                this.bill = {};
              }
              await this.createReceive(formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error({
              content: `失败: ${error}`,
              closable: true,
              duration: 0,
            });
          }
        } else {
          this.$Message.error({
            content: "创建失败!有必填项请填写",
            closable: true,
            duration: 0,
          });
        }
      });
      this.handleSubmitLoading = false;
    },
    // 快速创建回款记录
    copyNewReceive(data) {
      this.openedType = "create";
      this.openedReceive = null;
      if (this.bill._id) {
        this.formItem.bill = this.bill._id;
      }
    },
    getHeight() {
      this.formItemStyle.height = window.innerHeight - 130 + "px";
      let formItemHeight = Number(this.formItemStyle.height.slice(0, -2));
      if (
        formItemHeight < 660 ||
        this.formItem.type !== "trans" ||
        this.formItem.type !== "cash"
      ) {
        this.formItemStyle.overflowY = "scroll";
      } else {
        this.formItemStyle.overflowY = "hidden";
      }
    },
    openEditBillDrawer() {
      const data = this.bill;
      data.paidByCustomer = {};
      data.paidByCustomer._id = this.formItem.from;
      data.receivedBy = this.formItem.receivedBy;
      data.company = this.formItem.company;
      this.$refs.AddBillDrawer.openDrawer(data, "edit");
    },
    async updateBill(bill, type) {
      this.bill = bill;
      this.formItem.amount = bill.amount;
      this.formItem.bill = bill._id;
      this.formItem.type = bill.type;
      if (type === "edit") {
        this.updateLocalReceive({ id: this.openedReceive._id, data: bill });
      }
    },
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  mounted() {
    this.bankAccountList = this.simpleBankAccount;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
};
</script>

<style scoped lang="stylus">
.formItem
  display flex
  justify-content space-between

.formItem-left
  // margin-right 20px
  padding-left 16px
  width 400px

.formItem-right
  margin-bottom 100px
  // margin-right 20px
  width 370px

.formItem-left, .formItem-right
  overflow-y scroll
  overflow-x hidden

.bottom-button, .verify-button
  display flex

.bottom-button
  position fixed
  bottom 0px
  width 100%
  height 64px
  background-color #f2f6fa
  display flex
  align-items center
  z-index 1

.verify-button button
  margin-right 20px

.bill-item
  width 250px
  height 70px
  padding 8px
  margin 8px 0
  border 1px solid lightgray
  border-radius 4px
  cursor pointer
  display flex
  justify-content space-between

.billInfo-wrap
  width 380px
  padding 8px
  display flex
  height 100%
  justify-content space-between
  border 1px solid lightgray

.billInfo-wrap .info-item
  margin-bottom 10px

.active
  color #0168fa
  border 1px solid #0168fa
  box-shadow 0 2px 4px rgba(209, 230, 250, 1)
  transition 0.2s

.bill-card
  margin-bottom 16px
  cursor pointer

.drawer-content
  overflow-y hidden
  padding-left 0

.bill-list-title
  display flex
  justify-content space-between

.show-bill-button
  margin-bottom 15px

  .createBill
    margin-right 15px

.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between
</style>
